<template>
    <div class="qksm qksm5">
        <p><b>（五）国有资本经营预算收支情况</b></p>
        <p>
            {{$store.state.divData.divname}}2021年没有使用国有资本经营预算拨款安排的支出。
        </p>
        <p><b>（六）财政拨款安排的基本支出情况</b></p>
        <p v-if="num(T8.总计)==0">
            2021年无一般公共预算拨款安排的基本支出。
        </p>
        <template v-else>
            <div class="nogap">
                <p>
                    2021财政拨款安排的基本支出预算{{isMoney(T8.总计)}}万元（其中一般公共预算安排{{isMoney(T8.总计安排)}}万元），包括：
                </p>
                <p>
                    人员经费{{isMoney(T8.人员.总计)}}万元（其中一般公共预算安排{{isMoney(T8.人员.总计安排)}}万元），按部门预算支出经济分类主要包括：{{num(T8.人员.总计)==0 ? "无" : T8.人员.部门包括.join('、')}}。按政府预算支出经济分类主要包括：{{num(T8.人员.总计)==0 ? "无" : T8.人员.政府包括.join('、')}}。
                </p>
                <p>
                    公用经费{{isMoney(T8.公用.总计)}}万元（其中一般公共预算安排{{isMoney(T8.公用.总计安排)}}万元），按部门预算支出经济分类主要包括：{{num(T8.公用.总计)==0 ? "无" : T8.公用.部门包括.join('、')}}。按政府预算支出经济分类主要包括：{{num(T8.公用.总计)==0 ? "无" : T8.公用.政府包括.join('、')}}。
                </p>
            </div>
        </template>
    </div>
</template>
<script>
    export default {
        name: "qksm5",
        props: {
            T8: {
                type: Object,
                default: "",
            },
        },
        data() {
            return {
                isPdf: this.$parent.isPdf
            }
        },

    };
</script>